export default __webpack_public_path__ + "static/small-2-19dccfab34a73084ab5e1f3b24f02ee8.png";